import { convertToCommonErrors } from '../../common/utils/errorUtils.js';
import { TypeKeys, generateActionId } from './actionsUtils.js';
import type { CrudAction, ErrorAction } from './actionsUtils.js';
import type { GenericError, LocalUsageResponse, RoamingUsageResponse } from '../../generated/api/models.js';

export interface GetSubscriptionLocalUsageAction extends CrudAction<TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE> {
  subscriptionId: string;
}

export interface GetSubscriptionLocalUsageFulfilledAction {
  subscriptionId: string;
  type: TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE_FULFILLED;
  response: LocalUsageResponse;
}

export type GetSubscriptionLocalUsageFailedAction = ErrorAction<TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE_FAILED>;

export const getSubscriptionLocalUsage = (subscriptionId: string): GetSubscriptionLocalUsageAction => ({
  id: generateActionId(),
  subscriptionId,
  type: TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE,
});

export const getSubscriptionLocalUsageFulfilled = (
  subscriptionId: string,
  response: LocalUsageResponse
): GetSubscriptionLocalUsageFulfilledAction => ({
  response,
  subscriptionId,
  type: TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE_FULFILLED,
});

export const getSubscriptionLocalUsageFailed = (
  message: string,
  status: number,
  errors?: GenericError[],
  params?: { [s: string]: string }
): GetSubscriptionLocalUsageFailedAction => ({
  errors: convertToCommonErrors(message, status, errors),
  params,
  type: TypeKeys.GET_SUBSCRIPTION_LOCAL_USAGE_FAILED,
});

export interface GetSubscriptionRoamingUsageAction extends CrudAction<TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE> {
  subscriptionId: string;
}

export interface GetSubscriptionRoamingUsageFulfilledAction {
  subscriptionId: string;
  type: TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE_FULFILLED;
  response: RoamingUsageResponse;
}

export type GetSubscriptionRoamingUsageFailedAction = ErrorAction<TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE_FAILED>;

export const getSubscriptionRoamingUsage = (subscriptionId: string): GetSubscriptionRoamingUsageAction => ({
  id: generateActionId(),
  subscriptionId,
  type: TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE,
});

export const getSubscriptionRoamingUsageFulfilled = (
  subscriptionId: string,
  response: RoamingUsageResponse
): GetSubscriptionRoamingUsageFulfilledAction => ({
  response,
  subscriptionId,
  type: TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE_FULFILLED,
});

export const getSubscriptionRoamingUsageFailed = (
  message: string,
  status: number,
  errors?: GenericError[],
  params?: { [s: string]: string }
): GetSubscriptionRoamingUsageFailedAction => ({
  errors: convertToCommonErrors(message, status, errors),
  params,
  type: TypeKeys.GET_SUBSCRIPTION_ROAMING_USAGE_FAILED,
});

export type EmployeeSubscriptionUsageActionTypes =
  | GetSubscriptionLocalUsageAction
  | GetSubscriptionLocalUsageFulfilledAction
  | GetSubscriptionLocalUsageFailedAction
  | GetSubscriptionRoamingUsageAction
  | GetSubscriptionRoamingUsageFulfilledAction
  | GetSubscriptionRoamingUsageFailedAction;
